module.exports = __webpack_public_path__ + "static/media/smallRail.31d66961.png";